import { jsx as _jsx } from "react/jsx-runtime";
import { CsgPrimitive } from '../CsgPrimitive';
// Routed through `<CsgPrimitive>`, where a CSG root is detected and evaluated: a combiner under a
// plain Node3D is the commonest root, and a bare `<Node3D>` would draw each child as a lone root.
// The registration also applies `visible`, which GenericNodeFallback ignores, so a hidden combiner
// (a real authoring pattern when siblings bake its geometry) hides its children.
export function CSGCombiner3D({ node, children }) {
    return (_jsx(CsgPrimitive, { node: node, properties: node.properties, children: children }));
}
//# sourceMappingURL=Component.js.map